import React, { Component } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { getDateFromHours } from 'helpers/_date-helpers';
import styles from './styles';
import DayInput from 'components/DayInput';
import TimeInput from 'components/TimeInput';
import { generateHoursObject, isSelectedTimeValid } from 'helpers/helpers';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getTimeFormat, DAY_PART } from 'common/dateFormatConfig';

class HoursEquipBlock extends Component {
  state = {
    values: {
      dayStart: '0',
      hourStart: '1',
      minuteStart: '00',
      amPmStart: DAY_PART[0],
      dayEnd: '0',
      hourEnd: '1',
      minuteEnd: '00',
      amPmEnd: DAY_PART[0],
      isShowHours: false,
    },
    isValid: true,
    errors: [],
    originValues: null,
  };

  componentDidMount() {
    const { sheet, itemHours } = this.props;
    const getTimeFormatHook = (hourObj) =>
      getTimeFormat(hourObj, this.props.timeFormat, this.props.dateFormat);
    const hourObj = sheet.travelTimeOnly
      ? {}
      : generateHoursObject(itemHours?.start, itemHours?.end, sheet.createdAt, getTimeFormatHook);

    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        ...hourObj,
        isShowHours: !itemHours.isWlHours,
      },
      originValues: { ...prevState.values, ...hourObj },
    }));
  }

  componentDidUpdate(prevProps) {
    if (_.isEqual(this.props, prevProps)) return;

    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        isShowHours: !this.props?.itemHours?.isWlHours,
      },
    }));

  }

  handleChange = (parts) => {
    const { updateResourceHours, sheet, itemHours } = this.props;

    const getTimeFormatHook = (hourObj) =>
      getTimeFormat(hourObj, this.props.timeFormat, this.props.dateFormat);
    this.setState(
      (prevState) => ({
        values: { ...prevState.values, ...parts },
      }),
      () => {
        const { isValid, errorsOnFields } = isSelectedTimeValid(
          this.state.values,
          getTimeFormatHook,
          this.props.dateFormat,
        );

        this.setState({ isValid, errors: errorsOnFields });
        const { start, end } = getDateFromHours(
          this.state.values,
          sheet.createdAt,
          getTimeFormatHook
        );
        const updatedHours = {
          start,
          end,
        };
        if (itemHours?.id) updatedHours.id = itemHours.id;

        if (!isValid) {
          updatedHours.error = true;
        } else {
          delete updatedHours.error;
        }
        updateResourceHours(updatedHours);
      }
    );
  };

  render() {
    const {
      classes,
      sheet,
    } = this.props;
    const { values, errors } = this.state;
    const canEdit = this.props.canEdit === undefined ? true : this.props.canEdit;

    const hasError = (...fields) => fields.some((field) => errors.includes(field));

    return (
      <div>
        {!sheet?.travelTimeOnly && values.isShowHours && (
          <div className={classes.flexBox}>
            <div style={{ width: '100%' }}>
              <div
                className={classnames(
                  classes.inlineFlex,
                  classes.rowWrapper,
                  classes.startTimeWrapper
                )}
              >
                <Typography
                  variant="body1"
                  color="textSecondary"
                  className={classnames(classes.regularFontWeight, classes.paddingBottom)}
                >
                  On Job Time:
                </Typography>
                <div className={classes.fields}>
                  <DayInput
                    value={values.dayStart}
                    onChange={(dayStart) => this.handleChange({ dayStart })}
                    baseDate={sheet.createdAt}
                    error={hasError('dayStart')}
                    disabled={!canEdit}
                  />
                  <TimeInput
                    value={{
                      hour: values.hourStart,
                      minute: values.minuteStart,
                      amPm: values.amPmStart,
                    }}
                    onChange={({ hour, minute, amPm }) =>
                      this.handleChange({ hourStart: hour, minuteStart: minute, amPmStart: amPm })
                    }
                    error={hasError('hourStart', 'minuteStart', 'amPmStart')}
                    disabled={!canEdit}
                  />
                </div>
              </div>
              <div className={classnames(classes.inlineFlex, classes.rowWrapper)}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  className={classnames(
                    classes.regularFontWeight,
                    classes.paddingBottom,
                    classes.mobileHidden
                  )}
                >
                  &nbsp;
                </Typography>
                <div className={classes.fields}>
                  <DayInput
                    value={values.dayEnd}
                    onChange={(dayEnd) => this.handleChange({ dayEnd })}
                    baseDate={sheet.createdAt}
                    error={hasError('dayEnd')}
                    disabled={!canEdit}
                  />
                  <TimeInput
                    value={{ hour: values.hourEnd, minute: values.minuteEnd, amPm: values.amPmEnd }}
                    onChange={({ hour, minute, amPm }) =>
                      this.handleChange({ hourEnd: hour, minuteEnd: minute, amPmEnd: amPm })
                    }
                    error={hasError('hourEnd', 'minuteEnd', 'amPmEnd')}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </div>

            <div className={classes.inlineFlex}>
              {canEdit && (
                <IconButton
                  className={classnames(
                    classes.deleteButton,
                    classes.individualDeleteButton,
                  )}
                  onClick={this.props.deleteTime}
                  aria-label="Delete"
                  disableTouchRipple
                >
                  <CloseIcon />
                </IconButton>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

HoursEquipBlock.propTypes = {
  classes: propTypes.object.isRequired,
  itemHours: propTypes.object.isRequired,
  sheet: propTypes.object.isRequired,
  deleteTime: propTypes.func.isRequired,
  updateResourceHours: propTypes.func.isRequired,
  isWorkersType: propTypes.bool,
};

export default connect((state) => ({
  dateFormat: state.personalProfile.organization?.settings?.dateFormat,
  timeFormat: state.personalProfile.organization?.settings?.timeFormat,
}))(withStyles(styles)(HoursEquipBlock));
